<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <div *ngIf="currentPerson">
                <form>
                    <div class="flex-direction-horizontal">
                        <div class="flex-container-basic">
                            <app-image srcPath="{{ currentPerson.AvatarBlobPath }}" isApiImage="true" className="app-image-medium app-image-circle"></app-image>
                        </div>
                        <div class="flex-direction-vertical flex-container-basic">
                            <mat-form-field appearance="outline">
                                <mat-label>First Name</mat-label>
                                <input *ngIf="currentPerson" matInput name="FirstName" placeholder="First Name" [(ngModel)]="currentPerson.FirstName" />
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Last Name</mat-label>
                                <input *ngIf="currentPerson" matInput name="LastName" placeholder="Last Name" [(ngModel)]="currentPerson.LastName" />
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </div>
        </mat-card-header>
        <mat-card-content>
            <br />
            <br />
            <div class="container">
                <mat-slide-toggle>
                    <span>send me news (on occasion)</span>
                </mat-slide-toggle>
                <br />
                <mat-slide-toggle>
                    <span>Notify when Mendl is baking so I can order</span>
                </mat-slide-toggle>
                <br />
                <mat-form-field appearance="outline">
                    <mat-label>Notifiy me by phone</mat-label>
                    <input matInput name="PhoneNumber" placeholder="My Phone Number" />
                </mat-form-field>
                <br />
                <mat-form-field appearance="outline">
                    <mat-label>Notifiy me by Email</mat-label>
                    <input matInput name="EmailAddress" placeholder="My Email Address" />
                </mat-form-field>
            </div>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>

